import { BASE_URL } from '../../constants/defaultValues'
import Dictionary from '../dictionary'
import axios from 'axios'

const { sku } = Dictionary

const SKU = {
    list: async (id:string) => {
        return axios.get(BASE_URL + sku.list(id));
    },
}
export default SKU